// extracted by mini-css-extract-plugin
export default {"section":"Visualizations_section__VHKL8"};